import React, { FC } from "react";
import { Grid, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginBottom: "12px",
  },
  header: {
    fontSize: "0.9rem",
    marginBottom: "0.6rem",

    display: "flex",
    justifyContent: "center",
  },
  drugNamesContainer: {
    backgroundColor: theme.palette.background.default,
    padding: "0.5rem 0.5rem 0.5rem 0",
    minHeight: "1rem",
  },
}));

type SectionType = {
  drugs: string[];
};

const DrugNames: FC<SectionType> = ({ drugs }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container}>
      <Grid container justify="center">
        <Typography className={classes.header} variant="h6">
          Other Drug Names
        </Typography>
      </Grid>
      <Grid container className={classes.drugNamesContainer}>
        <Grid container justify="center">
          <Typography variant="body2">{drugs.length > 0 ? drugs.join("; ") : "N/A"}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DrugNames;
